import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { RtUICoreOverlayModule } from '../../core/overlay/overlay.module';
import { IconComponent } from '../icon/icon.component';
import { TooltipModule } from '../tooltip/tooltip.module';
import { IconHelpWithDropdownComponent } from './icon-help-with-dropdown.component';

@NgModule({
  imports: [
    I18nModule,
    CommonModule,
    TooltipModule,
    RtUICoreOverlayModule,
    IconComponent,
    IconHelpWithDropdownComponent,
  ],
  exports: [IconHelpWithDropdownComponent],
})
export class RtIconHelpWithDropdownModule {}
export * from './icon-help-with-dropdown.component';
